import React from "react";
import { AbsoluteFill, Img, staticFile, useCurrentFrame, interpolate, Easing } from "remotion";
import { COLORS, FONT, NEUTRAL, SAFE } from "../theme";
import { Kicker, useReveal } from "../components";

/* PDI con FOTO REAL de fondo (técnico escaneando en el taller) + panel de
   controles del checklist de preentrega encima. */

const clamp = { extrapolateLeft: "clamp", extrapolateRight: "clamp" } as const;
const ease = Easing.bezier(0.16, 1, 0.3, 1);

const CONTROLS = [
  "Carrocería y pintura",
  "Vidrios y espejos",
  "Llantas y presión",
  "Luces y direccionales",
  "Niveles y batería",
  "Interior y tablero",
  "Documentos y llaves",
  "GPS instalado y reportando",
];

const CheckItem: React.FC<{ text: string; start: number }> = ({ text, start }) => {
  const frame = useCurrentFrame();
  const r = useReveal(start, 13);
  const on = interpolate(frame, [start + 5, start + 16], [0, 1], clamp);
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 14, padding: "11px 4px", borderBottom: `1px solid ${NEUTRAL.line}`, ...r }}>
      <div style={{ width: 30, height: 30, borderRadius: 9, flex: "none", background: `rgba(91,196,137,${0.16 * on})`, border: `2px solid ${on > 0.5 ? COLORS.greenLight : NEUTRAL.lineStrong}`, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={COLORS.greenLight} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: on }}><path d="M5 12.5l4 4L19 7" /></svg>
      </div>
      <span style={{ fontFamily: FONT, fontWeight: 600, fontSize: 27, color: COLORS.ink }}>{text}</span>
    </div>
  );
};

export const SPDI: React.FC = () => {
  const frame = useCurrentFrame();
  const scale = interpolate(frame, [0, 250], [1.05, 1.12], { ...clamp, easing: Easing.linear });
  const fadeIn = interpolate(frame, [0, 14], [0, 1], clamp);
  const titleOp = interpolate(frame, [10, 30], [0, 1], clamp);
  const titleY = interpolate(frame, [10, 30], [22, 0], { ...clamp, easing: ease });
  const panelIn = interpolate(frame, [16, 38], [0, 1], { ...clamp, easing: ease });

  return (
    <AbsoluteFill style={{ backgroundColor: "#000", overflow: "hidden" }}>
      <AbsoluteFill style={{ opacity: fadeIn }}>
        <Img src={staticFile("footage/escaneo-pdi.png")} style={{ width: "100%", height: "100%", objectFit: "cover", scale: String(scale), transformOrigin: "40% 55%" }} />
      </AbsoluteFill>

      {/* scrim: oscurece arriba-izq (título) y la derecha (panel) */}
      <AbsoluteFill style={{ background: "linear-gradient(115deg, rgba(6,12,20,0.8) 0%, rgba(6,12,20,0.28) 40%, rgba(6,12,20,0) 60%)" }} />
      <AbsoluteFill style={{ background: "linear-gradient(270deg, rgba(6,12,20,0.86) 0%, rgba(6,12,20,0.5) 24%, rgba(6,12,20,0) 46%)" }} />

      {/* título */}
      <div style={{ position: "absolute", left: SAFE, top: SAFE * 0.8, opacity: titleOp, translate: `0px ${titleY}px`, maxWidth: 880 }}>
        <div style={{ marginBottom: 12 }}><Kicker color={COLORS.amber}>PDI · Inspección de preentrega</Kicker></div>
        <div style={{ fontFamily: FONT, fontWeight: 800, fontSize: 60, color: COLORS.white, letterSpacing: -1.2, lineHeight: 1.05, textShadow: "0 4px 24px rgba(0,0,0,0.55)" }}>
          El taller donde se revisa cada vehículo
        </div>
        <div style={{ fontFamily: FONT, fontWeight: 500, fontSize: 27, color: "#DCE6F0", marginTop: 10, textShadow: "0 2px 12px rgba(0,0,0,0.6)" }}>
          Antes de enviarlo al concesionario, se controla punto por punto.
        </div>
      </div>

      {/* panel de controles */}
      <div style={{ position: "absolute", right: SAFE, top: 250, width: 680, opacity: panelIn, translate: `${(1 - panelIn) * 30}px 0px`, background: "rgba(10,18,30,0.72)", border: `1px solid ${NEUTRAL.lineStrong}`, borderRadius: 20, padding: "24px 28px", backdropFilter: "blur(8px)" }}>
        <div style={{ fontFamily: FONT, fontWeight: 800, fontSize: 25, color: COLORS.white, marginBottom: 4 }}>Controles del PDI</div>
        <div style={{ fontFamily: FONT, fontSize: 17, color: COLORS.sub, marginBottom: 8 }}>Checklist obligatorio de preentrega</div>
        {CONTROLS.map((c, i) => (
          <CheckItem key={c} text={c} start={26 + i * 11} />
        ))}
      </div>
    </AbsoluteFill>
  );
};
